<template>
  <div
    class="sf-level sf-level-between sf-companies-list-progress__container"
    data-testid="companies-list-progress"
  >
    <div class="sf-level">
      <InsightsActions @download-as-excel="downloadCompaniesList" />
      <SearchInput
        v-if="!queryOverviewEnabled"
        class="!tw-min-w-60"
        :focused-at="searchFocusedAt"
        :placeholder="searchPlaceholder"
        :show-result-navigation="false"
        :model-value="searchTerm"
        @update:model-value="updateSearchTerm"
        @clear="clearSearchTerm"
      ></SearchInput>
    </div>
  </div>
</template>
<script>
import { mapState as mapPiniaState, mapActions as mapPiniaActions } from 'pinia'
import { useCompaniesStore } from '@app/insights/store/companies'
import { useColumnsStore } from '@app/insights/store/columns'
import { useSegmentsStore } from '@app/insights/store/segments'
import { useFiltersStore } from '@app/insights/store/filters'
import { useInsightsRootStore } from '@app/insights/store/insights-root'
import InsightsActions from '../actions/insights-actions.vue'
import SearchInput from '@app/shared/vue/components/sf-search/search-input.vue'
import { downloadCompaniesExcel } from '@app/insights/utils/companies-excel-export'

export default {
  name: 'InsightsCompaniesListProgress',
  components: {
    SearchInput,
    InsightsActions,
  },
  provide() {
    return {
      isLite: this.isLite,
    }
  },
  props: {
    isLite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchFocusedAt: null,
    }
  },
  computed: {
    ...mapPiniaState(useCompaniesStore, [
      'companiesFullyLoaded',
      'companiesFullyLoadedAt',
      'searchTerm',
      'selectedCompanies',
      'allCompaniesProcessed',
      'sortedAndFilteredCompanies',
    ]),
    ...mapPiniaState(useSegmentsStore, ['segment', 'isSegmentLoading']),
    ...mapPiniaState(useFiltersStore, ['activeFilters']),
    ...mapPiniaState(useColumnsStore, ['companyColumns']),
    ...mapPiniaState(useInsightsRootStore, ['queryOverviewEnabled']),

    loading() {
      return !this.allCompaniesProcessed
    },
    searchPlaceholder() {
      return I18n.t('companies_overview.progress_v2.search_placeholder')
    },
  },
  created() {
    // In the 2.0 layout the search (and its Cmd/Ctrl-F shortcut) lives in the
    // table menu bar instead, so this toolbar leaves it alone.
    if (this.queryOverviewEnabled) return
    window.addEventListener('keydown', this.handleKeyboardSearch)
  },
  unmounted() {
    window.removeEventListener('keydown', this.handleKeyboardSearch)
  },
  methods: {
    ...mapPiniaActions(useCompaniesStore, ['updateSearchTerm']),
    handleKeyboardSearch(event) {
      if ((event.ctrlKey || event.metaKey) && event.key === 'f') {
        event.preventDefault()
        this.searchFocusedAt = Date.now()
      }
    },
    downloadCompaniesList() {
      downloadCompaniesExcel({
        companyColumns: this.companyColumns,
        sortedAndFilteredCompanies: this.sortedAndFilteredCompanies,
        selectedCompanies: this.selectedCompanies,
      })
    },
    clearSearchTerm() {
      this.updateSearchTerm('')
    },
  },
}
</script>

<style scoped lang="scss">
.sf-companies-list-progress {
  &__container {
    grid-area: info;

    .inline-alert-banner {
      height: 36px;
    }
  }
}
</style>
